import { createIcon } from '@chakra-ui/react';

const ChevronDownIcon = createIcon({
  displayName: "ChevronDownIcon",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
});

export { ChevronDownIcon };
